import { DataTable, Dialog, Loader } from "@/components";
import { Button, Input, Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui";
import useDistributionRulesByGL from "./useDistributionRulesByGL";
import { Search } from "lucide-react";
import { GL_ACC } from "./consts";

const DistributionRulesByGL = () => {
  const {
    activeStatusTab,
    columns,
    ruleStatusTabs,
    onSave,
    glList,
    onStatusTabChange,
    isAssignPending,
    isLoading,
    globalFilter,
    setGlobalFilter,
    showWarningDialog,
    setShowWarningDialog,
    validateGroupGl,
    onConfirm,
    isLockPlan,
    validateGroupGlCount,
    fromTraceability
  } = useDistributionRulesByGL();

  return (
    <div className="mt-4">
      {isLoading ? <Loader /> : 
        <>
          <Tabs value={activeStatusTab} onValueChange={onStatusTabChange}>
            <div className="flex flex-row items-center justify-between w-full">
              <TabsList className="gap-x-4 bg-transparent p-0">
                {ruleStatusTabs.map((tab) => (
                  <TabsTrigger
                    key={tab.value}
                    value={tab.value}
                    className="hover:cursor-pointer text-gray-400 hover:text-primary px-0 border-0 shadow-none data-[state=active]:rounded-none data-[state=active]:bg-transparent data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:text-primary data-[state=active]:shadow-none"
                  >
                    {tab.label}
                  </TabsTrigger>
                ))}
              </TabsList>
              <div>
                <Input
                  type="text"
                  placeholder="Search"
                  value={globalFilter ?? ""}
                  onChange={(e) => setGlobalFilter(e.target.value)}
                  className="w-full sm:w-72 bg-white h-[40px]"
                  startIcon={<Search className="w-4 h-4" />}
                  disabled={fromTraceability}
                />
              </div>
            </div>

            {ruleStatusTabs.map((tab) => (
              <TabsContent key={tab.value} value={tab.value} className="w-full">
                <div className="overflow-x-auto w-full">
                  <div className="min-w-[1180px]">
                    <DataTable
                      columns={columns}
                      data={glList || []}
                      className="mt-4 w-full shadow-none border-0 bg-transparent [&_td]:!h-[80px]"
                      tableWrapperClassName="px-0 bg-white rounded-lg overflow-hidden"
                      headerClass={{
                        row: "bg-primary-300 hover:bg-primary-300",
                        cell: "whitespace-normal p-1",
                      }}
                      paginationArr={[5, 10, 20, 50, 100]}
                      globalFilter={globalFilter}
                      setGlobalFilter={setGlobalFilter}
                      hideFooter={fromTraceability}
                    />
                  </div>
                </div>
              </TabsContent>
            ))}
          </Tabs>

          {!isLockPlan && !fromTraceability && <div className="mt-8 flex justify-end">
            <Button type="button" className="h-[40px] min-w-[100px]" onClick={onSave} disabled={isAssignPending}>
              {isAssignPending ? <Loader variant="secondary" /> : <></>} Save
            </Button>
          </div>}
        </>
      }

      <Dialog 
        open={showWarningDialog}
        setOpen={setShowWarningDialog}
        title={<div className="text-2xl font-bold text-primary">
          {"Warning"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>}
        onSave={onConfirm}
        saveText="Yes"
        cancelText="No"
        isLoading={isAssignPending}
        contentClassName="lg:!max-w-[600px] lg:!w-[600px]"
      >
          {validateGroupGl?.length ?
            <>
              <p>The group allocation GL for following GL(s) should match across planned and actuals.</p>
              <ul className="my-4 list-disc pl-4 text-[14px] text-primary font-semibold">
                {validateGroupGl?.map((data: any) => <li><i>{`GL Account - ${data?.[GL_ACC]}`}</i></li>)}
              </ul>
            </> : <></>
          }
          {validateGroupGlCount?.length ?
            <>
              <p>The group distribution GL count is mismatch across planned and actuals.</p>
              <ul className="my-4 list-disc pl-4 text-[14px] text-primary font-semibold">
                {validateGroupGlCount?.map((data: any) => <li>
                  <i> GL Account - {data?.[GL_ACC]}</i><br />
                  <i> Planned: {data?.planCount}</i><br/>
                  <i> Actuals: {data?.actualCount}</i>
                </li>)}
              </ul>
            </> : <></>
          }
          Are you want to sure to update?
      </Dialog>
    </div>
  );
};

export default DistributionRulesByGL;
